module.exports = __webpack_public_path__ + "img/RAP1.ed2ee418.png";